import { Box, Card, CardContent, Typography } from "@mui/material"
import React, { ChangeEvent } from "react"
import { customPalette } from "../../../../../../../../../../theme"
import { FormSelectInput } from "../../../../../../../../../components/inputs/select-input/FormSelectInput"
import { BaseSelectOption } from "../../../../../../../../../components/inputs/select-input/BaseSelectInput"

interface IProps<T> {
  title: string
  id: string
  label: string
  selectedOption: T | undefined
  options: BaseSelectOption<T>[]
  errors?: Record<string, string | undefined>
  handleChange?(event: ChangeEvent<HTMLInputElement>): void
}

export function BSBuildingFondationForm<T>({
  title,
  id,
  label,
  selectedOption,
  options,
  errors,
  handleChange,
}: Readonly<IProps<T>>): React.JSX.Element {
  return (
    <Card
      sx={{
        backgroundColor: customPalette.white,
        borderRadius: 3,
        mb: 3,
        boxShadow: "2px 4px 20px 0px rgba(0, 0, 0, 0.05)",
      }}>
      <CardContent>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            width: "100%",
            p: 1,
            mb: 1,
          }}>
          <Typography variant="body2" fontWeight={600} sx={{ color: customPalette.darkBlue2 }}>
            {title}
          </Typography>
          <Box
            sx={{
              flexGrow: 1,
              height: "2px",
              backgroundColor: customPalette.lightBlue1,
              marginLeft: "8px",
            }}
          />
        </Box>
        <FormSelectInput
          id={id}
          label={label}
          mode="event"
          selectedOption={selectedOption}
          options={options}
          handleEventChange={handleChange}
          errors={errors}
        />
      </CardContent>
    </Card>
  )
}
